import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withSnackbar } from "notistack";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from "@material-ui/core/Divider";
import TestCard from "./TestCard";
import SERVER_ADDRESS from "../../../../config";
import {
  startTestState,
  returnTestGrade,
  useTestState,
  useStartTime,
} from "../../../../ilabx-grade-return";
import store from "../../../../reduxstore";

const useStyles = makeStyles((theme) => ({
  grid: {
    flexGrow: 1,
  },
  categorybar: {
    padding: theme.spacing(4),
  },
  divider: {
    width: "100%",
    height: 1,
  },
  paper: {
    marginTop: theme.spacing(4),
  },
  grade: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

//随机从数组中选取count个元素
function getRandomArrayElements(arr, count) {
  let shuffled = arr.slice(),
    i = arr.length,
    min = i - count,
    temp,
    index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
}

//获取构件信息
function useGoujians(initValue, number) {
  const [goujians, setGoujians] = useState(initValue);
  useEffect(() => {
    fetch(`${SERVER_ADDRESS}/api/goujians.json/`, {
      headers: {
        Accept: "application/json, text/plain, */*",
      },
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        //close dialog after finish post
        setGoujians(getRandomArrayElements(data, number));
        //成功后的反馈SnackBar
        // enqueueSnackbar("网络畅通", {
        //   variant: "success"
        // });
      })
      .catch((error) => {
        //失败后显示错误SnackBar
        console.log(error);
      });

    return () => {
      setGoujians(initValue);
    };
  }, []);
  return goujians;
}

function TestPage(props) {
  const { account } = store.getState();

  console.log({ account });

  const classes = useStyles();
  const { number, score } = props;
  const totalGrade = number * score;
  const goujians = useGoujians([], number);

  const [specification, setSpecification] = useState([]);

  //ilabx update test state
  useTestState();
  const testStartTime = useStartTime();

  //回答完全部问题后自动提交成绩
  // 防止二次提交
  // const [allreadySubmit, setAllreadySubmit] = useState(false);
  useEffect(() => {
    //提交全部问题，并且得分不为0时
    if (
      specification.length === number &&
      calculateGrade(specification) !== 0
    ) {
      if (account.vlabToken) {
        //提交成绩到北大Vlab平台，仅当acount存在token时进行此操作
        const grade = Number(calculateGrade(specification));
        const timeNow = new Date();
        const minuteCost = Math.ceil(
          (timeNow.getTime() - testStartTime.getTime()) / 60000
        );

        fetch("http://162.105.209.225/admin/score/insertScore", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "APP-Auth-Token": account.vlabToken,
          },
          mode: "cors",
          body: JSON.stringify({
            experimentName: "清官式大木作虚拟仿真教学实验",
            machineScore: grade,
            examTime: minuteCost,
            detailsInfomation: JSON.stringify(specification),
          }),
        })
          .then((res) => {
            console.log(res);
            if (!res.ok) {
              throw Error(res.statusText);
            }
            return res;
          })
          .then((data) => {
            console.log({ data });

            //提交成功后的反馈SnackBar
            props.enqueueSnackbar(`成功提交测试成绩,本次测试成绩为${grade}`, {
              variant: "success",
            });
          })
          .catch((error) => {
            // 失败后显示错误SnackBar;
            console.log(error);
            props.enqueueSnackbar("测试成绩提交失败", {
              variant: "error",
            });
          });
      } else {
        handleSubmit(`${SERVER_ADDRESS}/api/vtestgrade/`, {
          grade: String(calculateGrade(specification)),
          test_type: "a",
          specification: JSON.stringify(specification),
        })();
      }
    }
  }, [specification.length]); //确保答案length没变时，不会反复提交，例如提交后再navigate到原页面上时

  //用于TestCard返回成绩
  const submitAnswer = (rightAnswer, studentAnswer) => {
    setSpecification((state, props) => {
      return [
        ...state,
        {
          rightAnswer: rightAnswer,
          studentAnswer: studentAnswer,
        },
      ];
    });
  };

  //  提交按钮ref
  let buttonRefs = [];
  for (let index = 0; index < number; index++) {
    const ref = React.createRef();
    buttonRefs.push(ref);
  }

  //提交成绩至服务器
  const handleSubmit = (postUrl, formValue) => {
    return () => {
      fetch(postUrl, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/json",
        },
        mode: "cors",
        credentials: "include",
        body: JSON.stringify(formValue),
      })
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then((data) => {
          console.log(data);

          //提交成绩至实验空间
          const timeNow = new Date();
          const minuteCost = Math.ceil(
            (timeNow.getTime() - testStartTime.getTime()) / 60000
          );
          returnTestGrade("构件辨识实验", formValue.grade, minuteCost);

          //提交成功后的反馈SnackBar
          props.enqueueSnackbar(
            `成功提交测试成绩,本次测试成绩为${formValue.grade}`,
            {
              variant: "success",
            }
          );
        })
        .catch((error) => {
          // 失败后显示错误SnackBar;
          console.log(error);
          props.enqueueSnackbar("测试成绩提交失败", {
            variant: "error",
          });
        });
    };
  };

  const calculateGrade = (specification) => {
    let grade = 0;
    specification.forEach(({ rightAnswer, studentAnswer }) => {
      grade += rightAnswer === studentAnswer ? score : 0;
    });
    return grade;
  };

  return (
    <Grid container className={classes.grid} spacing={2}>
      <Grid
        container
        item
        xs={12}
        component={Paper}
        className={classes.paper}
        justify="center"
      >
        <Typography variant="h6" color="textPrimary" className={classes.grade}>
          {"测试成绩: " + calculateGrade(specification)}/{totalGrade}
        </Typography>
        <Button
          color="secondary"
          variant="contained"
          component="span"
          size="small"
          onClick={() => {
            buttonRefs.forEach((buttonRef) => {
              buttonRef.current.click();
            });
          }}
          disabled={specification.length === number}
        >
          提交全部试题
        </Button>
      </Grid>

      <Divider className={classes.divider} />
      {goujians
        ? goujians.map((goujian, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={goujian.id}>
              <TestCard
                goujian={goujian}
                submitAnswer={submitAnswer}
                submitButtonRef={buttonRefs[index]}
                postionMedia
              />
            </Grid>
          ))
        : null}
    </Grid>
  );
}
export default withSnackbar(TestPage);
